// NOX-197 (#15683) renamed the canonical duty from "Messkonzept vorbereiten" to
// "Messkonzept erstellen", but duties instantiated before the rename keep the old
// wording, so both variants can appear in live data.
const METER_LIST_TODO_LABELS = [
  "3.1. Messkonzept vorbereiten und Angebote Messstellenbetrieb einholen",
  "3.1. Messkonzept erstellen und Angebote Messstellenbetrieb einholen"
];

export function isMeterListTodo(todoLabel: string) {
  return METER_LIST_TODO_LABELS.includes(todoLabel);
}
